import { AnyView, InitializedPlayerStoreState, InputPinPhase } from '../playerStore.types';
import { Direction } from './reducers.types';

export function toInputPinPhase(phase: AnyView['phase']): InputPinPhase {
  return phase === 'results' ? 'results' : 'input';
}

export function nextPhase<P>(phase: P, phaseOrder: readonly P[], direction: Direction): P | null {
  const index = phaseOrder.indexOf(phase);
  if (index === -1) {
    return null;
  }
  return phaseOrder[index + direction] || null;
}

export function applyViewToState(state: InitializedPlayerStoreState, pinId: string, nextView: AnyView) {
  state.pinState[pinId].view = nextView;

  return {
    ...state,
    currentView: nextView,
  };
}
